import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { fetchLicenseRenewal } from 'dashboard/actions/license-renewal/license-renewal.actions';
import { isChainHeadSelector } from 'selectors';
import { checkAccess } from 'app/actions/app.actions';
import template from './license-renewal-widget.html';
import lspUtilsService from 'utils/lsp-utils-service';

export const LICENSE_RENEWAL_SERVICE = 'licenseRenewalService';

const mapStateToThis = (state) => {
  const { session, config, licenseRenewal } = state;
  const { retailerDashboard, retailer, multistore, role, adminId } = session;
  const { licenseRenewalContactUrl, licenseRenewalEnabled } = config;
  const { retailers, isLoading } = licenseRenewal;

  const isChainHead = isChainHeadSelector(state);

  return {
    retailer,
    multistore,
    role,
    retailerDashboard,
    licenseRenewalContactUrl,
    retailers,
    isLoading,
    isChainHead,
    licenseRenewalEnabled,
    adminId,
    isEmpty: retailers.length === 0,
  };
};

const mapDispatchToThis = {
  checkAccess,
  fetchLicenseRenewal,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class LicenceRenewalWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.isRenewalLinkVisible =
      this.checkAccess(LICENSE_RENEWAL_SERVICE) &&
      (!this.multistore ||
        (this.multistore && this.retailer.licensingAccess && this.role === 'RETAILER_SECONDARY') ||
        (this.multistore && this.role === 'RETAILER_PRIMARY'));
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    if (this.licenseRenewalEnabled) {
      this.$scope.$applyAsync(this.fetchLicenseRenewal(retailerId));
    }
  }

  $onDestroy() {
    this.unsubscribe();
  }

  redirectToLSP() {
    lspUtilsService.redirectToLSP('Licensing', this.adminId); 
  }
}

export default class LicenceRenewalWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
    this.template = template;
    this.controller = LicenceRenewalWidgetController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/license-renewal/license-renewal-widget-component.js